import React, { useEffect, useState } from "react";
import Maincomponent from "../../../Components/Maincomponent/Maincomponent";
import { Tabhelper } from "../../../Helper/Tabhelper";
import axios from "axios";
import Apiurl from "../../../Apiurl";
import { useParams } from "react-router-dom";

export default function Clientview() {
  const apiurl = Apiurl();
  const [jsonList, setJsonList] = useState([]);
  const [clientdata, setclientdata] = useState([]);
  const { id } = useParams();

  const initialData = {
    name: "Client View",
    link: "/student_profile",
    active: "no",
  };
  async function fetchdata() {
    try {
      const response = await axios.get(apiurl + `studentreg/${id}/`);
      setclientdata(response.data);
    } catch (error) {
      alert("Network error");
    }
  }
  // useEffect to add initial data to the JSON list
  useEffect(() => {
    fetchdata();
    //    Tabhelper(initialData,setJsonList);
  }, []);
  return (
    <Maincomponent tabname={"Client View"}>
      <div className="component-sub">
        <div className="component-sub1">
          <div className="multistephead">
            <b>CLIENT PROFILE</b>
          </div>
          <br />
          <div className="Billcompmain">
            <div className="Billcompmain2">
              <div className="multistepcontainer1">
                <div className="multistepsubcontainer1">
                  <div className="multisteptable">
                    <div
                      className="multisteptablerow"
                      style={{ padding: "5px" }}
                    >
                      <div className="multisteptablecell1">Name</div>
                      <div className="multisteptablecell2">
                        {clientdata.std_name}
                      </div>
                    </div>
                    <div className="multisteptablerow" style={{ padding: "5px" }}>
                      <div className="multisteptablecell1">ID</div>
                      <div className="multisteptablecell2">
                        {clientdata.student_id}
                      </div>
                    </div>
                    <div className="multisteptablerow">
                      <div className="multisteptablecell1">Contact</div>
                      <div className="multisteptablecell2">
                        {clientdata.contact1}
                      </div>
                    </div>
                    <div className="multisteptablerow">
                      <div className="multisteptablecell1">
                        Alternative Number
                      </div>
                      <div className="multisteptablecell2">
                        {clientdata.contact2}
                      </div>
                    </div>
                    <div className="multisteptablerow">
                      <div className="multisteptablecell1">Address</div>
                      <div className="multisteptablecell2">
                        {clientdata.address}
                      </div>
                    </div>
                    <div className="multisteptablerow">
                      <div className="multisteptablecell1">District</div>
                      <div className="multisteptablecell2">
                        {clientdata.district}
                      </div>
                    </div>
                    <div className="multisteptablerow">
                      <div className="multisteptablecell1">State</div>
                      <div className="multisteptablecell2">
                        {clientdata.state}
                      </div>
                    </div>
                    <div className="multisteptablerow">
                      <div className="multisteptablecell1">Pincode</div>
                      <div className="multisteptablecell2">
                        {clientdata.pincode}
                      </div>
                    </div>
                    <div className="multisteptablerow">
                      <div className="multisteptablecell1">Price</div>
                      <div className="multisteptablecell2">
                        {clientdata.total_amount}
                      </div>
                    </div>
                    <div className="multisteptablerow">
                      <div className="multisteptablecell1">Status</div>
                      <div className="multisteptablecell2">
                        {clientdata.status}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <br />
          <br />
          <div className="Billcompmain"></div>
        </div>
      </div>
    </Maincomponent>
  );
}
